import { render, staticRenderFns } from "./DataTemplateManager.vue?vue&type=template&id=26343536&scoped=true&"
import script from "./DataTemplateManager.vue?vue&type=script&lang=js&"
export * from "./DataTemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./DataTemplateManager.vue?vue&type=style&index=0&id=26343536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26343536",
  null
  
)

export default component.exports